<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="addConfig" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加配置</el-button>
      </div>
      <ele-data-table ref="table" :config="table" :choose.sync="choose" row-class-name="custom-row-class" highlight-current-row>
        <template>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column prop="name" label="名称" show-overflow-tooltip align="center" />
          <el-table-column prop="beginTime" label="重置时间" show-overflow-tooltip align="center" />
          <el-table-column prop="endTime" label="归寝时间" show-overflow-tooltip align="center" />
          <el-table-column prop="state" label="状态" width="75px" align="center">
            <template #default="{ row }">
              <el-switch v-model="row.state" @change="editState(row)" active-value="1" inactive-value="2" />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <el-link @click="editConfig(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
              <el-popconfirm title="确定要删除此数据？" @onConfirm="deleteConfig(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 添加或修改考勤配置弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改考勤配置' : '添加考勤配置'"
      :visible.sync="showEdit"
      width="350px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="重置时间" prop="beginTime">
          <el-time-picker v-model="editForm.beginTime" placeholder="选择重置时间" value-format="HH:mm" format="HH:mm" style="width: 100%" />
        </el-form-item>
        <el-form-item label="归寝时间" prop="endTime">
          <el-time-picker v-model="editForm.endTime" placeholder="选择归寝时间" value-format="HH:mm" format="HH:mm" style="width: 100%" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false">取 消</el-button>
        <el-button type="primary" @click="saveConfig(editForm.id)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import { saveSignConfig, saveSignConfigState } from '@/config/api';

  export default {
    name: '',
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/dormitory/signConfigList',
          method: 'GET',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [],
        editForm: {
          beginTime: undefined,
          endTime: undefined,
          name: undefined,
        },
        editRules: {
          beginTime: [{ required: true, message: '请选择重置时间', trigger: 'change' }],
          endTime: [{ required: true, message: '请选择归寝时间', trigger: 'change' }],
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        },
        showEdit: false,
      };
    },
    methods: {
      // 打开添加弹窗
      addConfig() {
        this.showEdit = true;
      },
      // 打开编辑弹窗
      editConfig(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      // 保存
      saveConfig(id) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveSignConfig(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 删除配置
      deleteConfig(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        formData.append('state', 0);
        saveSignConfigState(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已删除' });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 更改状态
      editState(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        formData.append('state', row.state);
        saveSignConfigState(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已改变状态' });
            this.$refs.table.reload();
          } else {
            row.state = !row.state ? 1 : 2;
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped lang="scss"></style>
